import * as React from 'react';
import { Link } from 'react-router-dom';
import ContactForm from './ContactForm';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const [showContactForm, setShowContactForm] = React.useState(false);
  
  return (
    <footer style={{
      backgroundColor: '#1e293b',
      color: '#e2e8f0',
      padding: '60px 0 30px',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Background Pattern */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        opacity: 0.03,
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 80 80'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M0 0h80v80H0V0zm20 20v40h40V20H20zm20 35a15 15 0 1 1 0-30 15 15 0 0 1 0 30zm20 35a15 15 0 1 1 0-30 15 15 0 0 1 0 30z' opacity='.5'/%3E%3Cpath d='M15 15h50l-5 5H20v40l-5 5V15zm0 50h50V15L80 0v80H0l15-15zm32.07-32.07l3.54-3.54A15 15 0 0 1 29.4 50.6l3.53-3.53a10 10 0 1 0 14.14-14.14zM32.93 47.07a10 10 0 1 1 14.14-14.14L32.93 47.07z'/%3E%3C/g%3E%3C/svg%3E")`,
      }} />
      
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 20px',
        position: 'relative',
        zIndex: 1
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          flexWrap: 'wrap',
          gap: '40px',
          marginBottom: '40px'
        }}>
          {/* Brand Column */}
          <div style={{ flex: '1', minWidth: '300px', maxWidth: '400px', paddingLeft: '0' }}>
            <div style={{
              marginBottom: '0',
              marginTop: '-70px',
              textAlign: 'left',
              paddingLeft: '0'
            }}>
              <Link to="/" style={{ cursor: 'pointer' }}>
                <img 
                  src="/logo.png" 
                  alt="RoastMyListing.ai Logo"
                  style={{ 
                    width: '100%',
                    maxWidth: '340px',
                    height: 'auto',
                    display: 'block',
                    marginLeft: '-25px',
                    marginRight: 'auto'
                  }}
                />
              </Link>
            </div>
            <p style={{
              fontSize: '0.95rem',
              lineHeight: '1.6',
              color: '#cbd5e1',
              marginBottom: '20px',
              marginTop: '-55px',
              paddingLeft: '0'
            }}>
              A parody tool that provides brutally honest feedback on your Amazon listings using real data analysis and e-commerce best practices. We're not affiliated with Amazon, but we know what works.
            </p>
          </div>
          
          {/* Contact Info */}
          <div style={{ flex: '1', minWidth: '250px', maxWidth: '350px' }}>
            <h4 style={{
              fontSize: '1.1rem',
              fontWeight: 'bold',
              marginBottom: '20px',
              marginTop: '15px',
              color: 'white'
            }}>
              Contact Us
            </h4>
            <p style={{
              fontSize: '0.95rem',
              lineHeight: '1.6',
              color: '#cbd5e1',
              marginBottom: '15px'
            }}>
              Have questions or feedback? We'd love to hear from you! Our AI doesn't have feelings, but we do.
            </p>
            <button
              onClick={() => setShowContactForm(true)}
              style={{
                display: 'inline-block',
                padding: '10px 20px',
                backgroundColor: 'rgba(255, 87, 34, 0.1)',
                color: '#ff5722',
                borderRadius: '8px',
                textDecoration: 'none',
                fontWeight: '500',
                fontSize: '0.95rem',
                transition: 'all 0.2s ease',
                border: '1px solid rgba(255, 87, 34, 0.3)',
                cursor: 'pointer',
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(255, 87, 34, 0.2)';
                e.currentTarget.style.transform = 'translateY(-2px)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(255, 87, 34, 0.1)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}>
              Email Us
            </button>
          </div>

          {/* Legal Links */}
          <div style={{ flex: '1', minWidth: '250px', maxWidth: '350px' }}>
            <h4 style={{
              fontSize: '1.1rem',
              fontWeight: 'bold',
              marginBottom: '20px',
              marginTop: '15px',
              color: 'white'
            }}>
              Legal Information
            </h4>
            <ul style={{ 
              listStyle: 'none', 
              padding: 0, 
              margin: 0,
              fontSize: '0.95rem',
              lineHeight: '2'
            }}>
              <li>
                <Link 
                  to="/privacy-policy"
                  style={{ 
                    color: '#cbd5e1', 
                    textDecoration: 'none',
                    cursor: 'pointer',
                    transition: 'color 0.2s ease'
                  }}
                  onMouseOver={(e) => e.currentTarget.style.color = '#ff5722'}
                  onMouseOut={(e) => e.currentTarget.style.color = '#cbd5e1'}
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link 
                  to="/terms-of-service"
                  style={{ 
                    color: '#cbd5e1', 
                    textDecoration: 'none',
                    cursor: 'pointer',
                    transition: 'color 0.2s ease'
                  }}
                  onMouseOver={(e) => e.currentTarget.style.color = '#ff5722'}
                  onMouseOut={(e) => e.currentTarget.style.color = '#cbd5e1'}
                >
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link 
                  to="/earnings-disclaimer"
                  style={{ 
                    color: '#cbd5e1', 
                    textDecoration: 'none',
                    cursor: 'pointer',
                    transition: 'color 0.2s ease'
                  }}
                  onMouseOver={(e) => e.currentTarget.style.color = '#ff5722'}
                  onMouseOut={(e) => e.currentTarget.style.color = '#cbd5e1'}
                >
                  Earnings & Affiliate Disclaimer
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Disclaimer */}
        <div style={{
          backgroundColor: 'rgba(255, 255, 255, 0.05)',
          padding: '15px',
          borderRadius: '8px',
          marginBottom: '30px',
          fontSize: '0.85rem',
          color: '#94a3b8',
          lineHeight: '1.6',
          textAlign: 'left'
        }}>
          <p style={{ marginBottom: '10px' }}>
            <strong>Disclaimer:</strong> RoastMyListing.ai is a parody tool and is not affiliated with Amazon. 
            While we use real data analysis and e-commerce best practices to provide suggestions, 
            the testimonials are fictional, and the roasts are meant to be entertaining as well as informative.
            Results are not guaranteed, but the laughs are. Use at your own discretion.
          </p>
          <p style={{ marginBottom: '10px' }}>
            <strong>Affiliate Disclosure:</strong> RoastMyListing.ai is a participant in the Amazon Associates Program and other affiliate programs. 
            We may earn commissions through qualifying purchases made through links on this site. This site may contain 
            links to products or services for which we may receive compensation.
          </p>
          <p>
            <strong>Business Information:</strong> RoastMyListing.ai is operated by Sellers Arena Inc. DBA Seller Synapse. 
            We reserve the right to change from a free to a paid service at any time if the current model cannot be sustained.
          </p>
        </div>
        
        {/* Copyright */}
        <div style={{
          borderTop: '1px solid rgba(255, 255, 255, 0.1)',
          paddingTop: '20px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '15px'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px'
          }}>
            <p style={{
              fontSize: '0.9rem',
              color: '#94a3b8',
              margin: 0
            }}>
              &copy; {currentYear} Sellers Arena Inc - DBA Seller Synapse - All Rights Reserved
            </p>
          </div>
          <p style={{
            fontSize: '0.9rem',
            color: '#94a3b8',
            margin: 0
          }}>
            Made with ❤️ and a healthy dose of sarcasm for Amazon sellers
          </p>
        </div>
      </div>

      {showContactForm && (
        <ContactForm onClose={() => setShowContactForm(false)} />
      )}
    </footer>
  );
};

export default Footer;
